const homepageAltTextI18nDe = {
  // Banner Slider Images - Desktop
  'altTextBanner1': 'Modereparatur Service Repair Rebels Düsseldorf',
  'altTextBanner3': 'Professionelle Kleidungsreparatur und Änderungsservice',
  'altTextBanner4': 'Online Modereparatur Portal Repair Rebels',
  'altTextBanner7': 'Hochwertige Reparaturen für Textilien und Schuhe',
  'altTextBanner8': 'Repair Rebels - Modereparatuplatform',
  
  // Banner Slider Images - Mobile
  'altTextMobileBanner1': 'Online Modereparatur Service – Deutschland und Österreich',
  'altTextMobileBanner2': 'Online-Modereparatur-Service in Deutschland und Österreich',
  'altTextMobileBanner3': 'Professionelle Reparaturen für Kleidung und Schuhe',
  'altTextMobileBanner5': 'Nachhaltige & hochwertige Textil- und Schuhreparaturen',
  
  // Video Section
  'videoTitleRecommended': 'Repair Rebels Online-Modereparatur-Service - Wie funktioniert\'s?',
  
  // Club Section
  'altTextWomanImage': 'Repair Rebels Club – Mitgliedervorteile',
  
  // Partnerships Section
  'altTextPartnershipsBgNew': 'Circular Fashion Reparatur Anbieter Deutschland',
  'altTextPartnershipsBgSm': 'White-Label Reparaturlösung - Repair Rebels',
  'altTextLogo': 'Repair Rebels - B2B Partnerschaften',
};

export default homepageAltTextI18nDe;
